/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Detail_Signals_Ai_Stage_Operate_DescInputs */

const en_directory_detail_signals_ai_stage_operate_desc = /** @type {(inputs: Directory_Detail_Signals_Ai_Stage_Operate_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API, non-interactive CLI, SDK, MCP server, webhooks, and machine-friendly authentication.`)
};

const zh_directory_detail_signals_ai_stage_operate_desc = /** @type {(inputs: Directory_Detail_Signals_Ai_Stage_Operate_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API、非交互 CLI、SDK、MCP 服务器、webhooks 与机器友好的认证方式。`)
};

/**
* | output |
* | --- |
* | "API, non-interactive CLI, SDK, MCP server, webhooks, and machine-friendly authentication." |
*
* @param {Directory_Detail_Signals_Ai_Stage_Operate_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_signals_ai_stage_operate_desc = /** @type {((inputs?: Directory_Detail_Signals_Ai_Stage_Operate_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Signals_Ai_Stage_Operate_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_signals_ai_stage_operate_desc(inputs)
	return zh_directory_detail_signals_ai_stage_operate_desc(inputs)
});
export { directory_detail_signals_ai_stage_operate_desc as "directory.detail.signals.ai_stage.operate_desc" }